import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <>
      <Navbar />
      <PageHeader
        crumbs={[
          { label: "首页", to: "/" },
          { label: "常见问题" },
        ]}
        title="常见问题"
        desc="这里汇总了读者最常关心的问题，关于更新、追更与阅读的疑问，都能在这里找到答案。"
      />
      <main className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <div className="space-y-3">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              return (
                <div key={f.q} className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : idx)}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                      <i className="ri-question-line mr-2 text-primary-500" />
                      {f.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                    >
                      <i className="ri-arrow-down-s-line" />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-100 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-4 rounded-2xl border border-background-200 bg-background-100 px-6 py-8 text-center sm:flex-row sm:text-left">
            <div>
              <h2 className="font-heading text-lg font-bold text-foreground-950">还有别的问题？</h2>
              <p className="mt-1 text-sm text-foreground-600">找不到答案，欢迎直接联系叮咚漫画网团队。</p>
            </div>
            <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-600">
              <i className="ri-chat-3-line" /> 联系客服
            </Link>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </>
  );
}